<template>
  <!-- Transition pour l'animation de la modal -->
  <transition name="modal">
    <div class="sef-modal-mask" v-if="isOpen">
      <div class="card" :class="type">

        <div class="card-header">
          <div class="card-title">
            <!-- Icône et titre de l'en-tête -->
            <i :class="icon" style="font-size: 25px" />
            <p style="margin-left: 4px">{{modalTitle}}</p>
          </div>
          <div class="btn-actions-pane-right">
            <p class="modal-information" v-html="information"></p>
            <div class="btn-group-sm btn-group" role="group">
              <!-- Bouton de fermeture de la modal -->
              <a href="#" class="active btn btn-focus" @click="handleCloseModal">
                <i class="scf-close"></i>
              </a>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div class="card-body-container">
            <!-- Contenu de la modal -->
            <slot></slot>
          </div>
        </div>
        <div class="modal-footer">
          <button v-for="label in labels" :key="label.key" type="button" @click="label.method" :class="['btn', label.class]" :disabled="label.isDisabled">
            {{ label.label }}
          </button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
  import "@grapecity/wijmo.styles/wijmo.css";
  import "@grapecity/wijmo.vue2.core";

  export default {
    name: "BaseModal",
    props: {
      isOpen: {
        type: Boolean,
        default: false,
      },
      modalTitle: String,
      labels: {
        type: Array,
        default: () => [],
        required: true
      },
    },

    data() {
      return {};
    },

    methods: {
      handleCloseModal() {
        this.$emit('close');
      },

    },
  };
</script>

<style scoped>
  /* @import url("../fonts/fonts.css"); */
  .sef-modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: 0.1 0.3s ease;
  }

  .card {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: "D-DIN";
    width: auto;
    position: fixed;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: transparent !important;
  }

  .card.full {
    width: 80%;
  }

  .card.notif .card-title {
    margin-right: 15px !important;
  }

  .card.notif .modal-footer {
    justify-content: center;
  }

  .card.confirmation {
    width: 30%;
  }

  .modal-footer .btn-primary {
    background-color: #eee !important;
    padding: 5px 30px;
    font-weight: bold;
    font-size: 14px;
    border: 1px solid #e2e6ec !important;
  }

  .card .card-header {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    border-bottom-width: 1px;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-right: 5px;
    padding-left: 10px;
    height: 35px;
    background-color: #bbdbfd;
    border-radius: 6px 6px 0px 0px;
    font-size: 12pt;
    font-weight: bold;
    border-bottom: 2px solid #1973d2;
    box-sizing: unset !important;
  }

  .card .card-header p {
    margin-top: revert !important;
    margin-bottom: revert !important;
    font-size: 12pt !important;
  }

  .card .card-header a {
    border: none;
    box-shadow: none;
  }

  .card-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0 !important;
    color: black;
  }

  .card .btn-actions-pane-right {
    margin-left: auto;
    white-space: nowrap;
    display: flex;
    flex-direction: row;
    align-items: baseline;
  }

  .card .card-header .btn-group,
  .btn-group-vertical {
    position: relative;
    display: -ms-inline-flexbox;
    display: inline-flex;
    vertical-align: middle;
  }

  .card .card-header a {
    text-decoration: none;
  }

  .card .card-header a.btn.btn-focus i {
    /* margin-left: 10px;
          margin-right: 10px; */
    color: #1973d2;
    font-size: 12pt;
  }

  .card .card-header a.btn.btn-focus i:hover {
    opacity: 0.5;
  }

  .card-body {
    padding: unset !important;
  }

  .card .card-body-container {
    padding: 10px;
    overflow: hidden;
    overflow-y: auto;
    background: #f4f6fb;
    max-height: 680px;
  }

  .card .card-body-container p {
    font-size: 11pt;
  }

  .card.full .card-body-container {
    height: 70vh;
  }

  .card .notif .card-body-container {
    height: auto;
  }

  /* .card.confirmation .card-body-container{
          height: 100px;
      } */

  .card .modal-footer {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    padding: 1rem;
    border-top: 1px solid #e9ecef;
    background: #f4f6fb;
  }

  .modal-enter-active,
  .modal-leave-active {
    transition: opacity 0.5s;
  }

  .btn-primary {
    color: #030f40;
    background-color: #eeeeee;
    border: 1px solid #030f40 !important;
  }

  .btn-success {
    background-color: "#aadc14" !important;
  }
  .btn-danger {
    background-color: "#e04644" !important; 
  }

  .btn {
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

  .btn:not(:disabled):not(.disabled) {
    cursor: pointer;
  }

  .btn-primary:hover {
    color: #030f40;
    background-color: #dddddd;
    border-color: #030f40;
  }

  .modal-footer> :not(:last-child) {
    margin-right: 0.25rem;
  }

  .modal-enter,
  .modal-leave-to {
    opacity: 0;
  }

  .modal-information {
    font-weight: normal;
  }

  .wj-content.wj-dropdown {
    width: 100%;
  }

  .highlight {
    margin-bottom: 0;
    color: white;
    background-color: #343a40;
    width: 25%;
    padding-top: 2px;
  }

  .row {
    margin-bottom: 15px;
  }

  .mb-15 {
    margin-bottom: 15px;
  }

  .mt-15 {
    margin-top: 15px;
  }

  .ml-15 {
    margin-left: 15px;
  }

  .sp-container {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-evenly;
    align-content: center;
    gap: 10px;
    padding: 10px;
    min-width: 300px;
    color: black;
  }

  .spc-label {
    flex: 1;
  }

  .spc-content {
    flex: 2;
  }

  .spc-content select {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    appearance: none;
    outline: 0;
    box-shadow: none;
    border: 0 !important;
    background: #fff;
    background-image: none;
    flex: 1;
    padding: 0 0.5em;
    color: #000000;
    cursor: pointer;
    font-size: 14px;
    padding-right: 40px;
    padding-left: 10px;
  }

  .spc-content select::-ms-expand {
    display: none;
  }

  .spc-content {
    position: relative;
    display: flex;
    width: auto;
    height: 30px;
    line-height: 30px;
    background: #fff;
    overflow: hidden;
    border-radius: 5px;
    font-family: "D-DIN";
  }

  .spc-content::after {
    content: "\25BC";
    position: absolute;
    top: 0;
    right: 0;
    padding: 0 8px;
    background: #fff;
    cursor: pointer;
    pointer-events: none;
    transition: 0.25s all ease;
    border-left: 1px solid #eee;
  }
</style>